module.exports = __webpack_public_path__ + "img/画板 15.f7080f70.jpg";